var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9781 16.2682L23.4373 20.7274C24.1868 21.4771 24.1868 22.6925 23.4373 23.4422C22.6822 24.1788 21.4775 24.1788 20.7224 23.4422L16.2632 18.984C12.0533 21.7985 6.39505 20.9605 3.1816 17.0467C-0.0318439 13.1328 0.247701 7.41963 3.82789 3.83817C7.40809 0.256709 13.1212 -0.0248551 17.0362 3.18721C20.9512 6.39927 21.7911 12.0573 18.9781 16.2682ZM17.7599 10.8048C17.7599 6.96089 14.6438 3.84479 10.7999 3.84479C6.95773 3.84903 3.84411 6.96265 3.83987 10.8048C3.83987 14.6487 6.95597 17.7648 10.7999 17.7648C14.6438 17.7648 17.7599 14.6487 17.7599 10.8048Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.46ec609313a2dc585dbf3f956bdda5f0.svg";
export { ForwardRef as ReactComponent };